module.exports = __webpack_public_path__ + "img/jpg.99a4a452.png";